import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './services/auth-guard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./landing/landing.module').then(m => m.LandingPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'product/:productId',
    loadChildren: () => import('./product-display/product-display.module').then(m => m.ProductDisplayPageModule)
  },
  {
    path: 'messages',
    loadChildren: () => import('./messages/messages.module').then(m => m.MessagesPageModule)
  },
  {
    path: 'account',
    loadChildren: () => import('./account/account.module').then(m => m.AccountPageModule)
  },
  {
    path: 'category/:categoryId',
    loadChildren: () => import('./category-landing/category-landing.module').then(m => m.CategoryLandingPageModule)
  },
  {
    path: 'shop/:shopId',
    loadChildren: () => import('./first-shop/first-shop.module').then(m => m.FirstShopPageModule)
  },
  {
    path: 'seller',
    loadChildren: () => import('./seller/seller.module').then(m => m.SellerSignupPageModule)
  },
  {
    path: 'my-products',
    loadChildren: () => import('./my-products/my-products.module').then(m => m.MyProductsPageModule)
  },
  {
    path: 'shop-orders',
    loadChildren: () => import('./shop-orders/shop-orders.module').then(m => m.ShopOrdersPageModule)
  },
  {
    path: 'my-product-bag',
    loadChildren: () => import('./my-product-bag/my-product-bag.module').then(m => m.MyProductBagPageModule)
  },
  {
    path: 'add-discount-code',
    loadChildren: () => import('./add-discount-code/add-discount-code.module').then(m => m.AddDiscountCodePageModule)
  },
  {
    path: 'my-orders',
    loadChildren: () => import('./my-orders/my-orders.module').then(m => m.MyOrdersPageModule)
  },
  {
    path: 'login-page',
    loadChildren: () => import('./login-page/login-page.module').then(m => m.LoginPagePageModule)
  },
  {
    path: 'sign-up',
    loadChildren: () => import('./sign-up/sign-up.module').then(m => m.SignUpPageModule)
  },
  {
    path: 'search',
    loadChildren: () => import('./search/search.module').then(m => m.SearchPageModule)
  },
  {
    path: 'saved-list',
    loadChildren: () => import('./saved-list/saved-list.module').then( m => m.SavedListPageModule)
  },
  {
    path: 'notification-page',
    loadChildren: () => import('./notification-page/notification-page.module').then( m => m.NotificationPagePageModule)
  },
  {
    path: 'account-setting',
    loadChildren: () => import('./account-setting/account-setting.module').then( m => m.AccountSettingPageModule)
  },
  {
    path: 'account-verification',
    loadChildren: () => import('./account-verification/account-verification.module').then( m => m.AccountVerificationPageModule)
  },
  {
    path: 'forget-password',
    loadChildren: () => import('./forget-password/forget-password.module').then( m => m.ForgetPasswordPageModule)
  },
  {
    path: 'reset-password',
    loadChildren: () => import('./reset-password/reset-password.module').then( m => m.ResetPasswordPageModule)
  },
  {
    path: 'store-list',
    loadChildren: () => import('./store-list/store-list.module').then( m => m.StoreListPageModule)
  },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
